export default function NoContent({ message = "No Content Found!" }) {
  return (
    <div className="w-full flex items-center justify-center h-10 max-w-7xl mx-auto p-2 text-gray-700 bg-gray-100 col-span-12">
      {message}
    </div>
  );
}
